// @ts-strict-ignore
import * as React from 'react';
import {HexColorPicker} from 'react-colorful';

import {ButtonReact} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {InputReact} from 'common/components/input';
import {InputSize} from 'common/components/input/types';
import {validateHexColor} from 'common/util/colors';

import styles from './index.module.styl';

/** A simple hex color picker consisting of a text input, an optional delete button, and a library hex color picker */
export function ColorPicker({
  color,
  onChange,
  onDelete,
}: {
  color: string;
  onChange: (color: string) => void;
  onDelete?: () => void;
}) {
  const handleInputChange = (event) => {
    const newColor = event.target.value;
    if (validateHexColor(newColor)) {
      onChange(newColor.toUpperCase());
    }
  };

  const handlePickerChange = (newColor) => {
    onChange(newColor.toUpperCase());
  };

  return (
    <div className={styles.mpColorPicker}>
      <div className={styles.line}>
        <InputReact value={color} size={InputSize.Medium} onChange={handleInputChange} />
        {onDelete && (
          <ButtonReact
            className={styles.button}
            theme={ButtonTheme.Secondary}
            icon='trashcan'
            onClick={() => onDelete()}
          />
        )}
      </div>
      <HexColorPicker color={color} onChange={handlePickerChange} />
    </div>
  );
}
